import * as React from "react"
const Action = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#000"
        d="m31.37.993-.198-.397-.397-.199c-.199 0-4.964-1.588-8.34 1.787L9.134 15.288c-1.787-1.191-3.376-2.383-3.574-1.985l-.794.595c-.397.397 1.787 3.375 3.574 5.361l-4.964 6.75a1.558 1.558 0 0 0-2.184 0l-.596.596a1.558 1.558 0 0 0 0 2.184l1.986 1.986a1.558 1.558 0 0 0 2.184 0l.595-.596a1.558 1.558 0 0 0 0-2.184l6.95-4.964c1.985 1.787 4.963 3.971 5.36 3.574l.794-.794c.2-.198-.794-1.985-2.183-3.574L29.582 8.935C32.96 5.956 31.37 1.19 31.37.993ZM15.288 20.847l-1.589-1.588 12.31-13.7-13.7 12.31-1.39-1.39L23.826 3.574c1.986-1.986 4.567-1.589 5.758-1.39.199 1.191.596 3.772-1.39 5.56L15.288 20.846Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h31.768v31.768H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default Action